/*
 * URL Hash Actions
 */

export const GET_URL_HASH = 'GET_URL_HASH'
export const SET_URL_HASH = 'SET_URL_HASH'
